import React from "react";
import { useSelector } from "react-redux";
import HandsonTable from "../../../components/table/handsonTable/handsonTable";

const OverviewTable = () => {
  const {
    data = [],
    colHeaders = [],
    columns = []
  } = useSelector((state) => state.multiLocationOverview.overviewTableData.tableInfo);

  return (
    <HandsonTable
      showExportFileButton
      data={data}
      colHeaders={colHeaders}
      columns={columns}
      width={1330}
      height={data.length === 1 || data.length === 2 ? data.length * 80 : data.length * 55}
      fragmentSelection
      stretchH="all"
      columnSorting={false}
    />
  );
};

export default OverviewTable;
